// JavaScript
const noScrollStyle = {
  position: "fixed", // Fixed position to prevent scrolling
  overflow: "hidden",
  width: "100%", // Prevent width reflow
  height: "100%", // You might need to adjust this if it causes issues
  top: "0", // Ensure the element stays in place
  left: "0", // Ensure the element stays in place
  right: "0", // Ensure the element stays in place
  "-webkit-overflow-scrolling": "touch", // iOS specific styling
};

const originalStyle = {
  position: "",
  overflow: "",
  width: "",
  height: "",
  top: "",
  left: "",
  right: "",
  "-webkit-overflow-scrolling": "",
};

function applyStyles(element, style) {
  for (const property in style) {
    element.style[property] = style[property];
  }
}

function ScrollDisable() {
  // Locking page scroll
  applyStyles(document.body, noScrollStyle);

  document.body.style.overflow = "hidden";
  // console.log("Scroll Disabled.");
}

function ScrollEnable() {
  // Turning page scroll back on
  applyStyles(document.body, originalStyle);

  document.body.style.overflow = "unset";

  // console.log("Scroll Enabled.");
}

export { ScrollEnable, ScrollDisable };
